var render = function render(){var _vm=this,_c=_vm._self._c;return _c('common-container',{staticClass:"bottom-six",attrs:{"title":"场所困人统计"}},[_c('BarCharts',{attrs:{"id":"cskrtj","lists":_vm.datas,"types":"vertial"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }